import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";

import { LooseComponentsModule, SharedModule } from "../../shared";

import { LoginWithDeviceComponent } from "./login-with-device.component";
import { LoginComponent } from "./login.component";

@NgModule({
  imports: [SharedModule, MatButtonModule, LooseComponentsModule],
  declarations: [LoginComponent, LoginWithDeviceComponent],
  exports: [LoginComponent, LoginWithDeviceComponent],
})
export class LoginModule {}
